import { SearchDeeplink, SearchLink } from 'store/railsBuilder/reducer.types';

import { DeeplinkParams, LinkParams } from 'utils/openDeeplink';

import getSearchDeeplinkItem from 'components/Ribbon/RibonItem/SearchDeeplink/utils/getSearchDeeplinkItem';

export default function getSearchDeeplinkOpeningParams(
    item: SearchDeeplink,
): DeeplinkParams & {
    deeplink?: string;
    link: SearchLink;
} {
    const link = getSearchDeeplinkItem(item)!;

    const deeplinkParams =
        link &&
        JSON.parse(link.playbackParams).reduce(
            (
                acc: LinkParams,
                currentParam: { key: string; value: string },
            ) => ({
                ...acc,
                [currentParam.key]: currentParam.value,
            }),
            {},
        );

    return {
        appleAppId: deeplinkParams?.appleAppId,
        androidMobileBundleId: deeplinkParams?.androidMobileBundleId,
        link,
    };
}
